import { useState } from "react";
import { useTranslation } from "react-i18next";
import { AlertTriangle } from "lucide-react";
import { DeleteAccountDialog } from "./DeleteAccountDialog";

export function DeleteAccountSection() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  return (
    <div className="rounded-xl border border-danger/20 bg-surface p-6">
      <h3 className="flex items-center gap-2 text-base font-semibold text-danger">
        <AlertTriangle size={18} />
        {t("account.dangerZone")}
      </h3>

      <div className="mt-4 flex flex-col gap-3 rounded-lg bg-danger/5 p-4 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <p className="text-sm font-medium text-heading">{t("account.deleteAccount")}</p>
          <p className="mt-1 text-xs text-muted">{t("account.deletion.description")}</p>
        </div>
        <button
          type="button"
          onClick={() => setOpen(true)}
          className="shrink-0 rounded-lg border border-danger/30 bg-danger/10 px-3.5 py-2 text-xs font-medium text-danger transition-colors hover:bg-danger/20"
        >
          {t("account.deleteAccount")}
        </button>
      </div>

      <DeleteAccountDialog open={open} onClose={() => setOpen(false)} />
    </div>
  );
}
